import React, { useEffect, useState, useContext } from "react";
import { fetchAdminDashboardStats } from "../dashboard/api-handlers.js";
import routes from "../../../config/routes-config.js";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
} from "chart.js";
import { Doughnut, Bar } from "react-chartjs-2";
import { LoginContext } from "../../../contexts/LoginContext.jsx";

const AdminDashboard = () => {
  const [deptData, setDeptdata] = useState({});

  const [domainData, setDomainData] = useState({});

  const [statsData, setStatsData] = useState({
    totalNumberOfProjects: 0,
    totalNumberOfTeacher: 0,
    totalNumberOfStudent: 0,
  });

  const { userAuthStatus, user } = useContext(LoginContext);

  useEffect(() => {
    if (userAuthStatus && user !== null) {
      fetchAdminDashboardStats(
        routes.admin.dashboard.statsUrl,
        user.token,
        setStatsData
      );

      fetchAdminDashboardStats(
        routes.admin.dashboard.departmentGraphUrl,
        user.token,
        setDeptdata
      );

      fetchAdminDashboardStats(
        routes.admin.dashboard.domainGraphUrl,
        user.token,
        setDomainData
      );
    }

    return () => {
      setStatsData({
        totalNumberOfProjects: 0,
        totalNumberOfTeacher: 0,
        totalNumberOfStudent: 0,
      });
      setDeptdata({});
      setDomainData({});
    };
  }, [userAuthStatus, user]);

  ChartJS.register(
    ArcElement,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    BarElement,
    Title
  );

  const doughnutData = {
    labels: Object.keys(deptData),
    datasets: [
      {
        data: Object.values(deptData),
        backgroundColor: [
          "rgba(255, 99, 132, 0.2)",
          "rgba(54, 162, 235, 0.2)",
          "rgba(255, 206, 86, 0.2)",
          "rgba(75, 192, 192, 0.2)",
          "rgba(153, 102, 255, 0.2)",
          "rgba(255, 159, 64, 0.2)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const barData = {
    labels: Object.keys(domainData),
    datasets: [
      {
        data: Object.values(domainData),
        backgroundColor: "#C2C0FF",
      },
    ],
  };

  const doughnutOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: "right",
      },
    },
  };

  const barOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
        position: "top",
      },
    },
  };

  return (
    <>
      <div className="w-screen flex flex-col justify-start">
        <h1 className="text-left text-4xl font-bold my-5 mx-28">
          Project Statistics
        </h1>
        <div className="flex flex-col items-center">
          <div className=" flex w-[calc(100vw-20rem)] border-t border-gray-300"></div>
        </div>

        <div className="p-10 relative sm:flex items-center justify-evenly">
          <div className="item xl:p-3 p-4 sm:w-1/5 w-full bg-[#f4f4ff] shadow-lg">
            <h2 className="text-center text-2xl font-normal m-2">
              Total Projects
            </h2>
            <h2 className="text-center text-3xl font-semibold m-1">
              {statsData.totalNumberOfProjects}
            </h2>
          </div>
          <div className="item xl:p-3 p-4 sm:w-1/5 w-full bg-[#f4f4ff] shadow-lg">
            <h2 className="text-center text-2xl font-normal m-2">
              Total Students
            </h2>
            <h2 className="text-center text-3xl font-semibold m-1">
              {statsData.totalNumberOfStudent}
            </h2>
          </div>
          <div className="item xl:p-3 p-4 sm:w-1/5 w-full bg-[#f4f4ff] shadow-lg">
            <h2 className="text-center text-2xl font-normal m-2">
              Total Teachers
            </h2>
            <h2 className="text-center text-3xl font-semibold m-1">
              {statsData.totalNumberOfTeacher}
            </h2>
          </div>
        </div>

        <div className="flex flex-col items-center">
          <div className=" flex w-[calc(100vw-20rem)] border-t border-gray-300"></div>
        </div>
        <div className="flex py-10 sm:flex-row flex-col flex-wrap justify-evenly items-center ">
          <div className="md:w-5/12 w-full flex items-center justify-around bg-slate-100 rounded-2xl">
            <div className="w-2/3 ">
              <h1 className="text-center text-2xl font-medium mt-10 -mb-14">
                Department Analysis
              </h1>
              <div className="-mb-10">
                <Doughnut data={doughnutData} options={doughnutOptions} />
              </div>
            </div>
          </div>
          <div className="md:w-5/12 md:h-full w-full flex items-center justify-around bg-slate-100 rounded-2xl">
            <div className="w-2/3">
              <h1 className="text-center text-2xl font-medium mb-6">
                Domain Analysis
              </h1>
              <div className="mb-10">
                <Bar data={barData} options={barOptions} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminDashboard;
